export const isCpfValid = (cpf) => cpf && cpf.replace(/\D/g, "").length === 11;
export const isCnpjValid = (cnpj) => cnpj && cnpj.replace(/\D/g, "").length === 14;
